import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IAuftraggeber, IDienstleistung, IProfileDto, IRolle } from "../types/Types";

/**
 * @author mb
 */
export const OfficeAPI = createApi({
    reducerPath: "officeAPI",
    baseQuery: fetchBaseQuery(
        {
            baseUrl: process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + "office",
            credentials: 'include'
        }),
    tagTypes: ['officeAPI'], // for caching
    endpoints: (builder) => ({
        getRollen: builder.mutation<IRolle[], void>(
            {
                query: () => ({
                    url: 'roles/',
                    method: 'get',
                    credentials: 'include'
                })
            }
        ),
       
        getAuftraggeberListe: builder.mutation<IAuftraggeber[], void>(
            {
                query: () => ({
                    url: 'auftraggeberliste',
                    method: 'get',
                    credentials: 'include'
                })
            }
        ),

        getVerkaeuferListe: builder.mutation<{ uid: string, name: string }[], string>(
            {
                query: (uid) => ({
                    url: 'verkaeuferliste/' + uid,
                    method: 'get',
                    credentials: 'include'
                })
            }
        ),

        getDienstleistungsListe: builder.mutation<IDienstleistung[], void>(
            {
                query: () => ({
                    url: 'dienstleistungsliste/',
                    method: 'get',
                    credentials: 'include'
                })
            }
        ),

        
        

    })
});

export const {

    useGetAuftraggeberListeMutation,
    useGetVerkaeuferListeMutation,
    useGetDienstleistungsListeMutation,

} = OfficeAPI;
